var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraypool(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2470_771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16553 3.49626C1.51514 3.7876 1.86475 4.07894 2.62224 4.07894C4.07894 4.07894 4.07894 2.91357 5.53565 2.91357C7.05063 2.91357 6.93409 4.07894 8.44907 4.07894C9.90578 4.07894 9.90578 2.91357 11.3625 2.91357C12.12 2.91357 12.4696 3.20492 12.8192 3.49626",
    stroke: "#90A1B9",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16553 6.99235C1.51514 7.28369 1.86475 7.57503 2.62224 7.57503C4.07894 7.57503 4.07894 6.40967 5.53565 6.40967C7.05063 6.40967 6.93409 7.57503 8.44907 7.57503C9.90578 7.57503 9.90578 6.40967 11.3625 6.40967C12.12 6.40967 12.4696 6.70101 12.8192 6.99235",
    stroke: "#90A1B9",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16553 10.4884C1.51514 10.7798 1.86475 11.0711 2.62224 11.0711C4.07894 11.0711 4.07894 9.90576 5.53565 9.90576C7.05063 9.90576 6.93409 11.0711 8.44907 11.0711C9.90578 11.0711 9.90578 9.90576 11.3625 9.90576C12.12 9.90576 12.4696 10.1971 12.8192 10.4884",
    stroke: "#90A1B9",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2470_771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9844,
    height: 13.9844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraypool);
export default __webpack_public_path__ + "static/media/graypool.6a34a2e7615661defb95cef19d769154.svg";
export { ForwardRef as ReactComponent };